module.exports = __webpack_public_path__ + "img/notification.ac9c48a1.png";